import * as DateFns from 'date-fns';
import { Market, OptionMarket } from '#/api/markets';
import { MarketSummary, OptionMarketSummary } from '#/api/markets-summary';

/**
 * @example '221028' => '28 Oct 22'
 */
export function formatExpiryDate(expiryDate: string): string {
  return DateFns.format(
    DateFns.parse(expiryDate, 'yyMMdd', new Date()),
    'dd MMM yy',
  );
}

export function isOptionMarket(market: Market): market is OptionMarket {
  return market.symbol.includes('-P-') || market.symbol.includes('-C-');
}

export function isOptionMarketSummary(
  marketSummary: MarketSummary,
): marketSummary is OptionMarketSummary {
  return (
    marketSummary.symbol.includes('-P-') || marketSummary.symbol.includes('-C-')
  );
}

// WIP: do not parse symbol, use values from API, as soon as API allows for that.
export function parseSymbol(symbol: Market['symbol']) {
  return symbol.split('-') as [
    baseCurrency: string,
    quoteCurrency: string,
    expiryDate: string,
    type: string,
    strikePrice: string,
  ];
}
